import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

const CardPagination = ({total, index, limit, indexChange}) => {
  let start = 1
  let end = 5
  let last = 5
  last = Math.ceil(total/limit) || 1;
  let indexList = []
  if (last <= 5 ){
    start = 1
    end = last
  } else {
    if (index > 3) {
      start = index - 2
      end = index + 2
    }
    if (end > last) {
      start = last - 4
      end = last
    }
  }
  for (let i = start; i <= end; i++) {
    indexList.push(i)
  }

  return (
    <Fragment>
      <ul className='pagination'>
        <li
          className='page-item'
          hidden={index === start}
          onClick={() => indexChange(index-1 >= start ? index-1 : start)}
        >
          <div className='page-link'>
            <FontAwesomeIcon icon={faAngleLeft}/>
            <span className='sr-only'>Previous</span>
          </div>
        </li>
        <div className='card-page-item-wrap'>
          <li className='page-item'>
            <div className='page-link'>
              {`${index} of ${last}`} 
            </div>
          </li>
        </div>
        <li
          className='page-item'
          hidden={index === last}
          onClick={() => indexChange(index+1 <= last ? index+1 : end)}
        >
          <div className='page-link'>
            <FontAwesomeIcon icon={faAngleRight}/>
            <span className='sr-only'>Next</span>
          </div>
        </li>
      </ul>
    </Fragment>
  );
}

export default CardPagination;
